module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/slider_button-bff6b2b75955527dd631576ace544f44.svg";